import { isGerman } from '@/i18n/locale';

export function Disclaimer({ className = '' }: { className?: string }) {
  if (isGerman()) {
    return (
      <p className={`text-xs text-slate-muted leading-relaxed ${className}`}>
        ⚕️ Alma gibt allgemeine Hinweise zur Elternschaft, basierend auf
        veröffentlichten medizinischen Leitlinien. Sie ist{' '}
        <strong>kein Ersatz für professionelle ärztliche Behandlung</strong>.
        Bei Sorgen um die Gesundheit deines Babys wende dich an deine
        Kinderärztin. Im Notfall ruf die <strong>112</strong>.
      </p>
    );
  }
  return (
    <p className={`text-xs text-slate-muted leading-relaxed ${className}`}>
      ⚕️ Alma provides general parenting information based on published medical
      guidelines. It is <strong>not a substitute for professional medical care</strong>.
      For any concern about your baby's health, contact your pediatrician.
      In an emergency, call <strong>911</strong>.
    </p>
  );
}
